import { render } from "./BaseConfirmationModal.vue?vue&type=template&id=7193b04f&scoped=true&ts=true"
import script from "./BaseConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./BaseConfirmationModal.vue?vue&type=script&lang=ts"

import "./BaseConfirmationModal.vue?vue&type=style&index=0&id=7193b04f&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7193b04f"]])

export default __exports__